function ImageMapper({ mapper, src, items = [] }) {
  const handleImgLoad = e => {
    const img = e.target;
    const original_width = img.width;
    document.querySelector('#source-image').width = '900';

    mapper.create(img, { original_width });
    mapper.createItems(items);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="card shadow mb-5">
        <div className="card-body">
          <section className="section " id="area-creator">
            <div id="image-container">
              <img alt="" id="source-image" src={src} onLoad={handleImgLoad} />
            </div>

            <div id="mapper-container">
              <canvas id="mapper-canvas"></canvas>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default ImageMapper;
